export default "/_next/static/chunks/fonts/GraphikRegular-329746577f94a4f1785ee927355989aa.otf";